import _ from "lodash";

import Pagination from '../pagination';
import { mapActions, mapState} from 'vuex';
import Modal from '@/components/modal.vue'
import CompanyBody from '@/components/CompanyBody.vue'

// For partsearch multi
const extraFields = ['tempQuery', 'tempQuery2', 'tempQuery3', 'tempQuery4', 'tempQuery5'];

export default {
  props: {
    broadcastsExplicit: Array
  },  
  components: {
    Pagination,
    Modal,
    CompanyBody,
  },
  data: () => ({
    isBootstrapped: false,
    isLoading: false,
    payloadDefaults: {},
    tempQuery: "",

    // Show company in modal
    selectedCompanyContacts:[],
    selectedCompany: {},
    showCompanyModal: false,
    newscategoryid: null,
  }),
  created() {
    _.each(this.payload, (v, k) => {
      this.$set(this.payloadDefaults, k, v);
    })
    if(this.broadcastsExplicit) return
    this.load()
  },
  watch: {
    // Route changes with different query params -> reload
    '$route.params'() {
      if(this.broadcastsExplicit) return
      this.load();
    }
  },
  computed: {
    ...mapState(['route', 'user', 'broadcastMap', 'typeMap']),
    availPageSizes(){
      return [{
        value: 10, 
        label: "10 results per page",
      },{
        value: 20, 
        label: "20 results per page",
      },{
        value: 50, 
        label: "50 results per page",
      },{
        value: 100, 
        label: "100 results per page",
      }]
    },
    paginationConfig(){

      const curPage = +this.payload.page;
      const numPages = Math.ceil(this.numResults / this.pageSize);
    
      if(numPages <= 7 ){
        return  _.map(_.times(numPages), pageNum => ({ num: pageNum + 1, isActive: pageNum + 1 === curPage }));
      }

      const pageItems = []
      if(curPage <= 4 && curPage !== 0){
        pageItems.push(..._.map(_.times(curPage - 1), pageNum => ({num: pageNum + 1})));
      } else if(curPage > 4){
        pageItems.push({ num: 1})
        pageItems.push({ isSpacer: true})
        pageItems.push({ num: curPage - 2}) // -2
        pageItems.push({ num: curPage -1 }) // -1
      }
      pageItems.push({ num: curPage, isActive: true}) 

      if(curPage >= numPages - 3 && curPage !== numPages){
        pageItems.push(..._.map(_.times(numPages - curPage), pageNum => ({num: curPage + pageNum + 1})));
      } else if(curPage < numPages - 3){
        pageItems.push({ num: curPage + 1}) 
        pageItems.push({ num: curPage + 2}) 
        pageItems.push({ isSpacer: true})
        pageItems.push({ num: numPages})

      }

      return pageItems;
    },
    numResults(){
      return this[this.numResultsName];
    },
    pageSize: {
      get: function () {
        return this.fetchActionName === 'getNews'
          ? 9
          : this.$store.state.pageSize
      },

      /** Updates size and resets broadcast pages, retaining conditions. @param {number|string} pageSize Selected size. @returns {void} */
      set: function (pageSize) {
        // Persist the selected size before requesting the corresponding result window.
        this.setPageSize(+pageSize)

        // A copied deep page can exceed the new window; keep saved mode and filters while resetting it.
        if (this.fetchActionName === "getBroadcasts" && this.route.query.page) {
          this.$router.replace({ query: { ...this.route.query, page: undefined } })
          return
        }

        // First-page and other list views retain their existing reload behavior.
        this.load()
      }
		},
  },
  methods: {
    ...mapActions(["getCompany", 'setPageSize']),

    fetchCompanyAndDisplayModal(id){
      this.getCompany(id).then(resp => {
        if(resp.status !== 200) throw new Error("TODO: not found. show error page")
        this.selectedCompany = resp.company;
        this.selectedCompanyContacts = resp.contacts;
        this.showCompanyModal = true;
      })
    },
    closeCompanyModal(){
      this.showCompanyModal = false;
    },
    navToCompany(item, skipIfNotLoggedIn){
      if(skipIfNotLoggedIn && !this.user) return;
      // console.log(item)
      if(this.isPossibleMatches || !this.user) return window.open(this.$router.resolve({path: `/companies/${item.companyId}`}).href, '_blank'); // brian added !this.user, so that anonymous users can still view limited company details
      this.fetchCompanyAndDisplayModal(item.companyId);
    },
    pageTo(page){
      if(page === "previous"){
        this.payload.page--;
      } else if(page === "next"){
       this.payload.page++;
      } else {
        this.payload.page = +page;
      }
      this.doSearch();
    },
    /** Restores URL filters and loads the selected list, preserving saved-search text. @returns {void} Updates reactive loading state. */
    load(){

      // Detail routes keep their existing dedicated loading path.
      if(this.route.query.id) return this.loadDetail(this.route.query.id)

      // Saved queries retain literal punctuation; other list searches keep their existing quote normalization.
      const queryText = (this.route.query.query || "").trim()
      this.route.query.query = this.route.query.savedSearch === "true" ? queryText : queryText.replaceAll("\"", "")

      // Restore advanced terms before copying the remaining route filters.
      
      this.tempQuery = this.route.query.query
      this.tempQuery2 = this.route.query.query2
      this.tempQuery3 = this.route.query.query3
      this.tempQuery4 = this.route.query.query4
      this.tempQuery5 = this.route.query.query5
      
      // Multiple terms -> show advanced search
      this.doShowAdvanced = _.compact([this.tempQuery, this.tempQuery2, this.tempQuery3, this.tempQuery4, this.tempQuery5]).length > 1;

      _.each(this.payload, (v, k) => {
        this.payload[k] = this.route.query[k] ? this.route.query[k] : this.payloadDefaults[k];
      })

      // Fix pageSize to 5 for broadcasts when on homepage
      if(this.$route.name === 'home'){
        if (!this.user) {
          this.payload.pageSize = 10;
        } else {
          this.payload.pageSize = 5;
        }
      }

      this.isLoading = true;

      if(this.fetchActionName == 'getNews') {
        setTimeout(() => {
          this.payload.catId = this.newscategoryid;

          this[this.fetchActionName](_.extend({pageSize: this.pageSize}, this.payload)).then(() => {
            this.isBootstrapped = true; 
            this.isLoading = false;
          })  
        }, 5); // Small delay to ensure updates propagate
      }
      else {
        if (this.fetchActionName === 'getBroadcasts') {
          let { category, type } = this.$route.params;
          if (!category && this.$route.meta?.broadcastCategory) {
            category = this.$route.meta.broadcastCategory;
          }
          category = category?.toLowerCase();
          type = type?.toLowerCase();

          if (category) {
            const categoryEntry = Object.values(this.broadcastMap).find(
              b => b.path === category
            );
            
            this.broadcastCategoryName = categoryEntry?.name ?? ''
            this.broadcastCategoryDescription = categoryEntry?.description ?? ''
            
            if (categoryEntry) {
              const categoryId = Object.keys(this.broadcastMap).find(
                key => this.broadcastMap[key] === categoryEntry
              );
              this.payload.listType = categoryId;
            }
          }
          if(type) {
            const typeId = this.typeMap[type];
  
            if (typeId) {
              this.payload.type = typeId;
            }
          }
        }


        this[this.fetchActionName](_.extend({pageSize: this.pageSize}, this.payload)).then(() => {
          this.isBootstrapped = true; 
          this.isLoading = false;
        })  
      }
     
      // If broadcast search on saved-search tab -> change to broadcast tab
      if(this.activeTab !== undefined){
        if(this.isSelectedCompanyMyCompany){
          this.activeTab = '1'
        } else if(this.activeTab === '2'){
          this.activeTab = '0'
        } 
      }
       
    },
    /**
     * Navigates with current filters and resets saved mode after condition edits.
     * @param {boolean} [doStayOnHomepageRaw=false] Keep homepage navigation when explicitly true.
     * @returns {*} Router result for early list exits; otherwise updates the route.
     */
    doSearch(doStayOnHomepageRaw = false){

      // Handle list-specific navigation before serializing broadcast conditions.
      const doStayOnHomepage = doStayOnHomepageRaw === true
      if(this.route.name === 'inventoryHits'){
        return this.$router.replace({ query: this.payload });
      }
      
      if(this.route.name === 'news'){
        if(!this.payload.id){
          delete this.payload.id;
        }
        return this.$router.replace({ query: this.payload });
      } 
      else if(this.route.name === 'broadcasts' || this.$route.meta?.seoLanding) {
        // Keep SEO landing URLs for guests.
        // Logged-in users are redirected away from SEO landings in the router.
        if (this.$route.meta?.seoLanding && !this.user) {
          return;
        }
        const { category, type } = this.$route.params;
        if (category || type) {
          this.$router.replace({
            name: 'broadcasts',
            query: this.$route.query 
          });
        }
      }
      // Omit inactive filters and first-page defaults from the navigation URL.
      const payloadToRoute = _.reduce(this.payload, (agg, v, k) => {
        if(k === 'page' && v === 1){
          agg[k] = undefined;
        } else {
          agg[k] = v ? v : undefined;
        }
        return agg;
      }, {})

      // Preserve original query text and optional advanced terms in the route.
      payloadToRoute.query = this.tempQuery;
      payloadToRoute.query2 = this.tempQuery2 || undefined;
      payloadToRoute.query3 = this.tempQuery3 || undefined;
      payloadToRoute.query4 = this.tempQuery4 || undefined;
      payloadToRoute.query5 = this.tempQuery5 || undefined;

      // Pagination retains alert semantics; changing a condition starts a new ordinary search.
      const changedConditions = ["query", "type", "listType", "companyId", "exactPhrase", "country", "favorites", "onlyOwnBroadcasts"]
        .some(key => String(payloadToRoute[key] || "") !== String(this.route.query[key] || ""))
      if (this.fetchActionName === "getBroadcasts" && this.payload.savedSearch && changedConditions) {
        this.payload.savedSearch = false
        payloadToRoute.savedSearch = undefined
      }

      // Compare conditions separately from pagination when selecting push versus replace.
      const diffMap = _.compact(_.map(payloadToRoute, (v, k) => {
        if(k === "page") return false;
        return (v !== this.route.query[k])
      }))

      const isHomePage = this.$route.name === 'home';

      // Search changed -> reset page
      if(diffMap.length || payloadToRoute.page !== this.route.query.page){
        if(diffMap.length && payloadToRoute.page === this.route.query.page){ //If pagination is different don't reset. This hack is needed for 'go back from detail page'
          payloadToRoute.page = undefined;
        }
        if(isHomePage && !doStayOnHomepage){
          this.$router.push({ name: "broadcasts", query: payloadToRoute })
        } else {
          this.$router.replace({ query: payloadToRoute }); // Update url while not creating history.
        }
      } else {
        //skip: route not changed.
      }
    },

  }
}